import { useSelector } from 'react-redux';

import { useAppDispatch } from 'store';

export const useAlbumsInterface = () => {
    const dispatch = useAppDispatch();

    // @ts-ignore
    const { albums } = useSelector((state) => state.dashboardReducer);

    return { albums };
};
